const action = require('../action/action');

const browseTree = Object.assign({}, action, {
    loadedSubrow: false,
    opened: false,
    newRow: false,
    subComponents: [],

    silentExecute: async function () {
        // Resolve the expand/collapse icon classes from the theme's icon map
        // (semantic names; see scripts/icons.contract.md).
        let iconElement = this.element.querySelector('i');
        if (this.opened) {
            this.opened = false;
            // Switch icon to the "expand" state by replacing the full className.
            iconElement.className = this.hm.app.icons.expandNode ?? '';

            //close
            this.hm.helper.hideElement(this.newRow);
        } else {
            this.opened = true;
            // Switch icon to the "collapse" state.
            iconElement.className = this.hm.app.icons.collapseNode ?? '';

            if (!this.loadedSubrow) {
                response = await action.silentExecute.call(this);

                let parentRow = this.element.closest('tr');
                let rowIndex = parentRow.rowIndex;
                let noCells = parentRow.cells.length;
                let parentTable = this.element.closest('table');

                this.newRow = parentTable.insertRow(rowIndex + 1);
                let fullCell = this.newRow.insertCell(-1);
                fullCell.colSpan = noCells;
                fullCell.classList.add('ps-20');

                let container = document.createElement('div');
                container.classList.add('border-start');

                for (let subComponentId in response.components) {
                    container.innerHTML += response.components[subComponentId];
                }

                fullCell.append(container);

                this.subComponents = this.subComponents.concat(this.hm.app.initComponents(fullCell));
                this.loadedSubrow = true;
            } else {
                //just open
                this.hm.helper.showElement(this.newRow);
            }
        }
    },

    removeSubcomponents: function () {
        this.hm.app.removeComponents(this.subComponents);
        this.subComponents = [];
    }
});

module.exports = browseTree;